export enum SitemapVersionLevelStatus {
    Active = "Active",
    Deleted = "Deleted",
    Uploading = "Uploading",
    Extracting = "Extracting",
    Reviewing = "Reviewing",
    Tiling = "Tiling",
    Failed = "Failed"
}